import { observer } from 'mobx-react';
import * as React from 'react';
import { T, TPlainTextKey } from '../../Translations';

interface Props {
  current: 1 | 2 | 3;
}

const steps: ReadonlyArray<TPlainTextKey> = [
  'Identity provider',
  'Configure your IdP',
  'Test attributes',
];

const Stepper: React.FC<Props> = ({ current }) => (
  <ol className="m-0 flex list-none flex-wrap items-center gap-2 p-0">
    {steps.map((step, index) => {
      const stepNumber = index + 1;
      const state: 'done' | 'now' | 'todo' =
        stepNumber < current ? 'done' : stepNumber === current ? 'now' : 'todo';

      return (
        <li key={step} className="flex items-center gap-2">
          {index > 0 && <span className="mx-1 h-px w-8 bg-border" aria-hidden="true" />}
          <span
            className={`flex items-center gap-2 text-sm font-semibold ${
              state === 'now'
                ? 'text-primary'
                : state === 'done'
                  ? 'text-accent'
                  : 'text-muted-foreground'
            }`}
          >
            <span
              className={`flex h-6 w-6 items-center justify-center rounded-full text-xs ${
                state === 'now'
                  ? 'bg-primary text-primary-foreground'
                  : state === 'done'
                    ? 'bg-accent/10 text-accent'
                    : 'bg-muted text-muted-foreground'
              }`}
            >
              {state === 'done' ? <>&#10003;</> : stepNumber}
            </span>
            <T kind={step} />
          </span>
        </li>
      );
    })}
  </ol>
);

export default observer(Stepper);
